module.exports = __webpack_public_path__ + "img/achievement_5.f944f156.png";